import types from './types.js';

const fetchSupersetReportDetailsBegin = () => ({
  type: types.FETCH_SUPERSET_REPORT_DETAILS_BEGIN
});

const fetchSupersetReportDetailsSuccess = report => ({
  type: types.FETCH_SUPERSET_REPORT_DETAILS_SUCCESS,
  payload: { report }
});

const fetchSupersetReportDetailsError = error => ({
  type: types.FETCH_SUPERSET_REPORT_DETAILS_ERROR,
  payload: { error }
});

const fetchSupersetTokenBegin = () => ({
  type: types.FETCH_SUPERSET_TOKEN_BEGIN
});

const fetchSupersetTokenSuccess = (token, filters) => (
  {
    type: types.FETCH_SUPERSET_TOKEN_SUCCESS,
    payload: { token, filters }
  });

const fetchSupersetTokenError = error => ({
  type: types.FETCH_SUPERSET_TOKEN_ERROR,
  payload: { error }
});

export default {
  fetchSupersetReportDetailsBegin,
  fetchSupersetReportDetailsSuccess,
  fetchSupersetReportDetailsError,
  fetchSupersetTokenBegin,
  fetchSupersetTokenSuccess,
  fetchSupersetTokenError,
};
